// MessageMenu.js
import React, { useState } from 'react';
import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    useClipboard,
    useToast,
} from '@chakra-ui/react';
import { ChevronDownIcon, CopyIcon, CheckIcon } from '@chakra-ui/icons';
import { FaCopy } from 'react-icons/fa';
import ConfirmationModal from './ConfirmationModal';

const MessageMenu = ({ onDuplicate, messageContent, isUserMessage = false }) => {
    const { hasCopied, onCopy } = useClipboard(messageContent);
    const [showModal, setShowModal] = useState(false);
    const toast = useToast();

    const handleCopyClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onCopy();
        toast({
            title: 'Copied!',
            description: 'Message copied to clipboard',
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
    };

    const handleDuplicateClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };

    const handleConfirmDuplicate = () => {
        if (onDuplicate) {
            onDuplicate();
        }
        setShowModal(false);
    };

    return (
        <>
            <Menu>
                {({ isOpen }) => (
                    <>
                        <MenuButton
                            as={IconButton}
                            icon={<ChevronDownIcon />}
                            size="xs"
                            variant="ghost"
                            aria-label="Message actions"
                            color="gray.500"
                            _hover={{
                                bg: 'gray.100',
                                color: 'gray.700',
                                transform: 'scale(1.05)'
                            }}
                            _active={{ bg: 'gray.200' }}
                            transition="all 0.2s"
                            onClick={e => e.stopPropagation()}
                            bg={isOpen ? 'gray.100' : 'transparent'}
                        />
                        <MenuList
                            bg="white"
                            border="1px"
                            borderColor="gray.200"
                            shadow="lg"
                            minW="180px"
                            zIndex={1000}
                        >
                            <MenuItem
                                icon={hasCopied ? <CheckIcon color="green.500" /> : <CopyIcon />}
                                onClick={handleCopyClick}
                                fontSize="sm"
                                color={hasCopied ? "green.600" : "gray.700"}
                                _hover={{ bg: 'gray.50' }}
                            >
                                {hasCopied ? 'Copied!' : 'Copy message'}
                            </MenuItem>
                            {!isUserMessage && onDuplicate && (
                                <MenuItem
                                    icon={<FaCopy />}
                                    onClick={handleDuplicateClick}
                                    fontSize="sm"
                                    color="gray.700"
                                    _hover={{ bg: 'gray.50' }}
                                >
                                    Duplicate conversation
                                </MenuItem>
                            )}
                        </MenuList>
                    </>
                )}
            </Menu>
            <ConfirmationModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={handleConfirmDuplicate}
                title="Duplicate Conversation"
                message="Are you sure you want to duplicate this conversation up to this message?"
                confirmButtonText="Duplicate"
                confirmButtonColorScheme="green"
            />
        </>
    );
};

export default MessageMenu;